import React from 'react';
const styles = {"org-slug-form":"OrgSlugForm-module__org-slug-form__ykkP-","field":"OrgSlugForm-module__field__69OpQ","label":"OrgSlugForm-module__label__tRO2K","input":"OrgSlugForm-module__input__IrWbH","submit":"OrgSlugForm-module__submit__EZQpw"};
export function OrgSlugForm({ action, method, value, isValid, onChange, onSubmit }) {
    return (React.createElement("form", { action: action, method: method, className: styles['org-slug-form'], onSubmit: onSubmit
            ? event => {
                event.preventDefault();
                onSubmit(value);
            }
            : undefined },
        React.createElement("label", { className: styles.field, htmlFor: "orgSlug" },
            React.createElement("span", { className: styles.label }, "Organization slug"),
            React.createElement("input", { id: "orgSlug", name: "orgSlug", type: "text", placeholder: "your-org", required: true, pattern: "\\S.*", value: value, onChange: event => onChange(event.target.value), className: styles.input })),
        React.createElement("button", { type: "submit", disabled: !isValid, className: styles.submit }, "Continue")));
}
//# sourceMappingURL=OrgSlugForm.js.map